import React, { useContext, useState } from 'react'
import { FormattedMessage } from '~/translations/utils'
import classNames from 'classnames'
import { SipContext } from '~/service/SipConn'
import { TicketType, PhoneNumbers } from '~/components/tickets/Show'
import Dropdown from '~/components/common/Dropdown'

type PropsType = {
  ticket: TicketType
  phoneNumbers: PhoneNumbers
}

const Call: React.FC<PropsType> = ({ ticket, phoneNumbers }) => {
  const { makeCall } = useContext(SipContext)

  const call = (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    value: string
  ) => {
    e.preventDefault()
    makeCall(value, { clientId: ticket.client.id, ticket: ticket.id })
  }

  return (
    <>
      <Dropdown
        right={true}
        trigger={
          <button
            className="button is-small"
            aria-haspopup="true"
            aria-controls="dropdown-menu"
          >
            <span>
              <FormattedMessage id="ticket / call" />
            </span>
            <span className="icon is-small">
              <i className="fas fa-angle-down" aria-hidden="true"></i>
            </span>
          </button>
        }
      >
        {phoneNumbers.contacts.map((contact, k) => (
          <a
            key={k}
            onClick={e => call(e, contact.value)}
            className="dropdown-item"
          >
            {contact.value}
          </a>
        ))}
      </Dropdown>
    </>
  )
}

export default Call
